<script setup>
import { ref, reactive, onBeforeMount, computed } from "vue";
import popupTitle from "./popupTitle.vue";
import { Toast } from "vant";
import { commonStore } from "@/store/common";
import useClipboard from "vue-clipboard3";
import { useI18n } from "vue-i18n";
const common_store = commonStore();
const { toClipboard } = useClipboard();
const { t } = useI18n();
const hashArr = computed(() => common_store.hashArr);
const BSC = "https://bscscan.com";
// const BSC = 'https://testnet.bscscan.com';
const toDetails = (hash) => {
  window.open(`${BSC}/tx/${hash}`);
  common_store.setAccountShow(false);
};
const copyLink = async () => {
  try {
    await toClipboard(common_store.address);
    Toast(t("copySuccess"));
  } catch (e) {
    Toast(t("copyError"));
  }
};
const toLink = () => {
  window.open(`${BSC}/token/${common_store.address}`);
  common_store.setAccountShow(false);
};
const closeFn = () => {
  common_store.setAccountShow(false);
};
const clearRecord = () => {
  common_store.clearHash();
};
</script>
<template>
  <div class="bind">
    <popup-title
      :title="$t('AccountTransfer.account')"
      @closeFn="closeFn"
    ></popup-title>
    <div class="bind-bg bgPadding">
      <ul class="main iptBg bgPadding">
        <li class="flex_between">
          <span class="Wcolor font500 font-Four">
            {{ common_store.address.slice(0, 6) }}...{{
              common_store.address.slice(-4)
            }}
          </span>
          <div class="Wcolor flex_start">
            <img src="@assets/accountImg/copy.png" alt="" class="icon" />
            <span class="font-Two" @click="copyLink">{{ $t("copy") }}</span>
          </div>
        </li>
        <li>
          <div class="Wcolor flex_start" @click="toLink()">
            <img src="@assets/accountImg/link_icon.png" alt="" class="icon" />
            <span class="font-Two">{{ $t("AccountTransfer.link") }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="record-ul bgPadding">
      <ul>
        <li
          class="flex_between record-title Wcolor Bold font-Four"
          v-if="hashArr.length == 0"
        >
          {{ $t("AccountTransfer.record") }}
        </li>
        <li class="flex_between record-title" v-else>
          <span class="Wcolor Bold">{{ $t("AccountTransfer.transfer") }}</span>
          <span class="redColor font-Two font500" @click="clearRecord">{{
            $t("AccountTransfer.clear")
          }}</span>
        </li>
      </ul>
      <ul class="record-ul_main">
        <li
          v-for="(item, key) in hashArr"
          :key="key"
          class="flex_between li-hash"
        >
          <span class="Wcolor font-Two font500">{{
            item.text ? $t(item.text) : "--"
          }}</span>
          <div
            class="flex_start font-Two lightGrey"
            @click="toDetails(item.hash)"
          >
            <span class="font500 font-Two"
              >{{ item.hash.slice(0, 4) }}...{{ item.hash.slice(-6) }}</span
            >
            <img src="@assets/accountImg/link_icon.png" alt="" class="icon" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bind {
  width: 315px;
  height: 330px;
  padding: 4px;
  background: url("../assets/commonImg/alert-bg2.png") no-repeat;
  background-size: 100% 100%;
  background-position: 0 0;
  z-index: 99;
}
.icon {
  width: 20px;
  margin-left: 4px;
}
.main {
  margin: 15px 0;
  border-radius: 10px;
  li {
    height: 40px;
    line-height: 40px;
  }
}
.record-ul {
  &_main {
    max-height: 120px;
    overflow-y: auto;
  }
}
.record-title {
  height: 40px;
  line-height: 40px;
}
.li-hash {
  height: 20px;
}
</style>
